<app-megamenu></app-megamenu>

<div class="our-team-page">
  <!-- Hero Section -->
  <div class="hero-section">
    <div class="container">
      <div class="hero-content">
        <h1>Meet Our Team</h1>
        <p class="hero-subtitle">
          Get to know the dedicated professionals behind Complete Pest Control. Our team brings years of hands-on experience and a commitment to dependable service, working together to deliver effective pest management solutions for every customer we serve.
        </p>
      </div>
    </div>
  </div>

  <!-- Team Members Section -->
  <div class="team-section">
    <div class="container">
      <div class="section-header">
        <h2>The People Behind Complete Pest Control</h2>
        <p>The leadership team at Complete Pest Control combines backgrounds in operations, business strategy, and technology. Their collective expertise helps guide the company’s growth while upholding the standards that shape our day-to-day work.</p>
        <p></p>
      </div>

      <div class="team-grid">
        <div *ngFor="let member of teamMembers" class="team-member-card">
          <mat-card class="member-card" [class.hiring-card]="member.isOpenPosition">
            <div class="member-image-container">
              <img *ngIf="!member.isOpenPosition" [src]="member.image" [alt]="member.name" class="member-image">
              <div *ngIf="member.isOpenPosition" class="profile-icon-container">
                <mat-icon class="profile-icon">account_circle</mat-icon>
              </div>
              <div *ngIf="member.isOpenPosition" class="hiring-overlay">
                <mat-icon class="hiring-icon">work</mat-icon>
              </div>
            </div>
            
            <mat-card-header class="member-header">
              <mat-card-title class="member-name" [class.hiring-title]="member.isOpenPosition">{{ member.name }}</mat-card-title>
              <mat-card-subtitle class="member-title">{{ member.title }}</mat-card-subtitle>
            </mat-card-header>

            <mat-card-content class="member-content">
              <p class="member-bio">{{ member.bio }}</p>
              
              <div class="member-experience">
                <mat-icon>{{ member.isOpenPosition ? 'search' : 'work' }}</mat-icon>
                <span>{{ member.experience }}</span>
              </div>

              <div class="specialties-section">
                <h4>{{ member.isOpenPosition ? 'What We\'re Looking For' : 'Areas of Expertise' }}</h4>
                <div class="specialties-list">
                  <span *ngFor="let specialty of member.specialties" class="specialty-chip" [class.hiring-chip]="member.isOpenPosition">
                    {{ specialty }}
                  </span>
                </div>
              </div>

              <div *ngIf="member.isOpenPosition" class="hiring-actions">
                <button mat-raised-button class="apply-btn" (click)="sendEmail()">
                  <mat-icon>email</mat-icon>
                  Apply Now
                </button>
                <button mat-button class="learn-more-btn" (click)="callPhone()">
                  <mat-icon>phone</mat-icon>
                  Learn More
                </button>
              </div>
            </mat-card-content>
          </mat-card>
        </div>
      </div>
    </div>
  </div>

  <!-- Company Values Section -->
  <div class="values-section">
    <div class="container">
      <h2>Our Values</h2>
      <div class="values-grid">
        <div class="value-item">
          <mat-icon class="value-icon">verified</mat-icon>
          <h3>Excellence</h3>
          <p>We strive for excellence in every service call, ensuring your pest problems are solved effectively and efficiently.</p>
        </div>
        <div class="value-item">
          <mat-icon class="value-icon">security</mat-icon>
          <h3>Safety First</h3>
          <p>The safety of your family, pets, and our technicians is our top priority in every treatment we perform.</p>
        </div>
        <div class="value-item">
          <mat-icon class="value-icon">favorite</mat-icon>
          <h3>Trust</h3>
          <p>We build lasting relationships with our customers through honest communication and reliable service.</p>
        </div>
        <div class="value-item">
          <mat-icon class="value-icon">lightbulb</mat-icon>
          <h3>Innovation</h3>
          <p>We continuously adopt new technologies and methods to provide the most effective pest control solutions.</p>
        </div>
      </div>
    </div>
  </div>

  <!-- Join Our Team Section -->
  <div class="careers-section">
    <div class="container">
      <div class="careers-content">
        <h2>Join Our Growing Team</h2>
        <p>
          Are you passionate about helping people and solving problems? We're always looking for dedicated professionals 
          to join our team. Complete Pest Control offers competitive compensation, comprehensive training, and opportunities 
          for career growth in the pest control industry.
        </p>
        <div class="careers-benefits">
          <div class="benefit-item">
            <mat-icon>school</mat-icon>
            <span>Comprehensive Training</span>
          </div>
          <div class="benefit-item">
            <mat-icon>trending_up</mat-icon>
            <span>Career Growth</span>
          </div>
          <div class="benefit-item">
            <mat-icon>favorite</mat-icon>
            <span>Health Benefits</span>
          </div>
          <div class="benefit-item">
            <mat-icon>schedule</mat-icon>
            <span>Flexible Schedule</span>
          </div>
        </div>
        <div class="careers-actions">
          <button mat-raised-button class="primary-btn" (click)="sendEmail()">
            <mat-icon>email</mat-icon>
            Contact Us About Careers
          </button>
          <button mat-button class="secondary-btn" (click)="callPhone()">
            <mat-icon>phone</mat-icon>
            Call {{ config.phone.display }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<app-footer></app-footer>